import type { InvivoSheetMaterialPlan } from "../../types/invivo_scene";
import { createLegacyNodeMaterial } from "./create_legacy_node_material";
import { LEGACY_VIEWER_NODE_MATERIALS } from "./legacy_node_materials";

function hasLegacySheetTextureSet(materialPlan: InvivoSheetMaterialPlan): boolean {
  return Boolean(
    materialPlan.previewTexture &&
      materialPlan.albedoRoughnessTexture &&
      materialPlan.xycaTexture &&
      materialPlan.dotsTexture &&
      materialPlan.crumplesTexture &&
      materialPlan.creasesTexture
  );
}

export function createSheetMaterial({
  scene,
  materialPlan,
}: {
  scene: unknown;
  materialPlan: InvivoSheetMaterialPlan;
}): unknown {
  if (!hasLegacySheetTextureSet(materialPlan)) {
    throw new Error(`Missing required legacy sheet textures for material "${materialPlan.name}".`);
  }

  const nodeMaterialInputs = {
    ...(materialPlan.baseColor ? { baseColor: materialPlan.baseColor } : {}),
    ...(materialPlan.tilingDots ? { tilingDots: materialPlan.tilingDots } : {}),
    ...(materialPlan.tilingCreases ? { tilingCreases: materialPlan.tilingCreases } : {}),
    ...(materialPlan.tilingCrumples ? { tilingCrumples: materialPlan.tilingCrumples } : {}),
    ...(typeof materialPlan.tilingMultiplier === "number" ? { tilingMultiplier: materialPlan.tilingMultiplier } : {}),
    ...(materialPlan.nodeMaterialInputs || {}),
  };

  return createLegacyNodeMaterial({
    scene,
    serializedMaterial: LEGACY_VIEWER_NODE_MATERIALS["sheet_material.json"] as Record<string, unknown>,
    materialName: `Invivo::sheet::${materialPlan.name}`,
    backFaceCulling: materialPlan.backFaceCulling,
    nodeMaterialInputs,
    textureBindings: {
      preview: materialPlan.previewTexture,
      AlbedoRoughness: materialPlan.albedoRoughnessTexture,
      XYCA: materialPlan.xycaTexture,
      Dots: materialPlan.dotsTexture,
      Crumples: materialPlan.crumplesTexture,
      Creases: materialPlan.creasesTexture,
      Fibers: materialPlan.fibersTexture,
    },
  });
}
